import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { HistoryMessage, PastSession, Usage } from '../models/chatbot.model';

export const ActivateThread = createAction('[Alio: Chatbot]: Activate Thread', props<{ threadId: string }>());

export const NewChat = createAction('[Alio: Chatbot]: New Chat');

export const RemoveConversation = createAction('[Alio: Chatbot]: Remove Conversation', props<{ threadId: string }>());

export const LoadUsage = createAction('[Alio: Chatbot]: Load Usage');

export const LoadUsageSuccess = createAction('[Alio: Chatbot]: Load Usage Success', props<{ usage: Usage }>());

export const LoadUsageFailed = createAction(
  '[Alio: Chatbot]: Load Usage Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const LoadSessions = createAction('[Alio: Chatbot]: Load Sessions');

export const LoadSessionsSuccess = createAction(
  '[Alio: Chatbot]: Load Sessions Success',
  props<{ sessions: PastSession[] }>(),
);

export const LoadSessionsFailed = createAction(
  '[Alio: Chatbot]: Load Sessions Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenSession = createAction('[Alio: Chatbot]: Open Session', props<{ sessionId: string }>());

export const LoadSessionHistory = createAction('[Alio: Chatbot]: Load Session History', props<{ sessionId: string }>());

export const LoadSessionHistorySuccess = createAction(
  '[Alio: Chatbot]: Load Session History Success',
  props<{ sessionId: string; history: HistoryMessage[] }>(),
);

export const LoadSessionHistoryFailed = createAction(
  '[Alio: Chatbot]: Load Session History Failed',
  props<{ sessionId: string; error: HttpErrorResponse }>(),
);

export const ActivateKpiThread = createAction(
  '[Alio: Chatbot]: Activate KPI Thread',
  props<{ kpiId: string; title: string }>(),
);

export const AskKpiQuestion = createAction(
  '[Alio: Chatbot]: Ask KPI Question',
  props<{ kpiId: string; title: string; message: string }>(),
);

export const CreateSession = createAction('[Alio: Chatbot]: Create Session', props<{ threadId: string }>());

export const CreateSessionSuccess = createAction(
  '[Alio: Chatbot]: Create Session Success',
  props<{ threadId: string; sessionId: string }>(),
);

export const CreateSessionFailed = createAction(
  '[Alio: Chatbot]: Create Session Failed',
  props<{ threadId: string; error: HttpErrorResponse }>(),
);

export const TypeMessage = createAction('[Alio: Chatbot]: Message Changed', props<{ message: string }>());

export const PostQuestion = createAction(
  '[Alio: Chatbot]: Post Question',
  props<{ threadId: string; message: string }>(),
);

export const PostQuestionSuccess = createAction(
  '[Alio: Chatbot]: Post Question Success',
  props<{ threadId: string; res: string }>(),
);

export const PostQuestionFailed = createAction(
  '[Alio: Chatbot]: Post Question Failed',
  props<{ threadId: string; error: HttpErrorResponse }>(),
);

export const CreateSessionAndPostQuestion = createAction(
  '[Alio: Chatbot]: Create Session And Post Question',
  props<{ threadId: string }>(),
);

export const CreateSessionAndPostQuestionSuccess = createAction(
  '[Alio: Chatbot]: Create Session And Post Question Success',
  props<{ threadId: string; sessionId: string }>(),
);

export const CreateSessionAndPostQuestionFailed = createAction(
  '[Alio: Chatbot]: Create Session And Post Question Failed',
  props<{ threadId: string; error: HttpErrorResponse }>(),
);
